import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于六合彩指南',
    description: '了解六合彩指南的品牌故事、核心价值和联系方式',
    url: 'https://liuhecai-zhinan.example.com/about',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '六合彩指南',
    url: 'https://liuhecai-zhinan.example.com',
    description: '汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@liuhecai-zhinan.example.com',
      availableLanguage: ['Chinese'],
    },
  };

  const values = [
    {
      icon: 'ri-shield-star-line',
      title: '权威可靠',
      desc: '所有内容经专业团队严格审核，确保资讯准确、来源可靠。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '用户至上',
      desc: '以用户需求为导向，持续优化内容质量和使用体验。',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: '专业深度',
      desc: '汇聚行业专家和资深玩家，提供有深度的分析和见解。',
    },
    {
      icon: 'ri-scales-line',
      title: '理性引导',
      desc: '倡导理性参与，提供全面的风险提示和投注指南。',
    },
  ];

  const milestones = [
    { year: '2020', title: '平台创立', desc: '六合彩指南正式上线，致力于提供权威六合彩资讯。' },
    { year: '2021', title: '内容扩展', desc: '文章数量突破100篇，建立完整的内容分类体系。' },
    { year: '2022', title: '用户突破', desc: '月活用户突破5万，成为行业领先资讯平台。' },
    { year: '2023', title: '专业升级', desc: '引入数据分析团队，推出深度数据报告服务。' },
    { year: '2024', title: '口碑认可', desc: '获得行业多项认可，用户好评率超过95%。' },
    { year: '2025', title: '持续创新', desc: '推出个性化推荐功能，月活用户突破10万。' },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 六合彩指南 | 品牌介绍与联系方式"
        description="了解六合彩指南的品牌故事、核心价值、发展历程和联系方式。我们致力于提供最权威的六合彩网站资讯，涵盖平台评测、开奖查询、玩法规则和选号技巧。"
        keywords="六合彩指南品牌,关于六合彩网站,六合彩联系方式"
        canonicalUrl="https://liuhecai-zhinan.example.com/about"
        schema={{ ...aboutSchema, ...orgSchema }}
      />
      <main className="pt-20 pb-10 md:pb-14">
        <div className="max-w-[960px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-6 mb-12 md:mb-16">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              关于六合彩指南
            </h1>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-[700px]">
              六合彩指南创立于2020年，是专注于六合彩资讯领域的中文内容平台。我们汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧，致力于帮助用户安全、理性地参与娱乐。
            </p>
          </section>

          <section className="mb-12 md:mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-8 text-center">
              我们的核心价值观
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {values.map((item) => (
                <div
                  key={item.title}
                  className="bg-background-50 rounded-lg border border-background-200/70 p-6 flex gap-4"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-12 md:mb-16">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-8 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
              <div className="space-y-8">
                {milestones.map((item, index) => (
                  <div
                    key={item.year}
                    className={`relative flex items-start gap-6 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className="md:w-1/2 flex items-center gap-4 md:justify-end">
                      <div className={`${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} flex-1`}>
                        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-2">
                          {item.year}
                        </span>
                        <h3 className="font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
                        <p className="text-sm text-foreground-600">{item.desc}</p>
                      </div>
                    </div>
                    <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 mt-1.5 z-10"></div>
                    <div className="md:w-1/2 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-600">contact@liuhecai-zhinan.example.com</p>
                  <p className="text-xs text-foreground-500 mt-0.5">工作日24小时内回复</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-900 mb-1">工作时间</h3>
                  <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                  <p className="text-xs text-foreground-500 mt-0.5">法定节假日休息</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}